import { makeStyles } from "../shared";

export const appStyles = makeStyles({
  root: {
    minHeight: "calc(100vh)",
  },
});
